<template>
  <ChatTemplate>
    <template v-slot:title>
      <div>#</div>
      <div>{{ tender.tenderNumber }}</div>.
      <div class="ml-1">
        {{ tender.title }}
      </div>
    </template>
    <template v-slot:items>
      <EventHistory
        :items="items"
        mode="big"
        :spr="spr"/>
    </template>
  </ChatTemplate>
</template>
<script>
import EventHistory from 'components/common/blocks/history/EventHistory.vue'
import ChatTemplate from 'components/common/blocks/history/ChatTemplate.vue'

/**
 * Согласования
 */
export default {
  name: 'dialogHistory',
  props: {
    /**
     * Данные согласовантов
     */
    items: {
      type: Array
    },
    /**
     * Данные тендеров
     */
    tender: {
      type: Object
    },
    spr: {
      type: Object
    }
  },
  components: {
    ChatTemplate,
    EventHistory
  }
}
</script>
